<template>
  <!-- não permitir decimaispontos, virgulas, etc -->
  <input
    type="number"
    :step="1"
    :value="displayValue"
    @input="updateValue($event.target.value)"
    class="form-control text-right"
    v-bind="$attrs"
  />
</template>

<script>
export default {
  name: 'IntegerInput',
  props: {
    value: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    displayValue() {
      return this.value !== null && this.value !== undefined ? parseInt(this.value) : '';
    }
  },
  methods: {
    updateValue(value) {
      let parsedValue = 0;

      try {
        parsedValue = parseInt(value, 10);
      } catch (error) {
        parsedValue = 0;
      }
      // // Permite sinal negativo e números
      // const numericValue = value.replace(/[^\d-]/g, '');

      // // Garante que o sinal negativo só apareça no início
      // const cleanValue = numericValue.replace(/(.)-+/g, '$1');

      // // Emitir valor como número ou null se vazio
      // let parsedValue = cleanValue === '' || cleanValue === '-' ? null : parseInt(cleanValue, 10);
      this.$emit('input', parsedValue);
    }
  }
};
</script>

<style scoped></style>
